import {
  FETCH_COUNTRY_WORK_PROFILE_BEGIN,
  FETCH_COUNTRY_WORK_PROFILE_SUCCESS,
  FETCH_COUNTRY_WORK_PROFILE_FAILURE,
} from '../actions/countryWorkProfile';

export const initialState = {
  error: null,
  isFetching: false,
  // Whether a Country Work Profile exists for the member: null until the fetch
  // resolves, then true/false from the payload (account-api reports it). The
  // "U.S. Work" tab is gated on it; the null state lets callers tell "not yet
  // known" apart from "known to have none".
  present: null,
  immigrationStatus: null,
  authorizedToWork: null,
  restrictionsOnWork: null,
  legalIds: [],
  legalIdDetails: {},
  legalIdTitles: {},
};

export const authorizedToWorkStatus = (value) => {
  if (value === 'authorized') return 'yes';
  if (value === 'expired') return 'no';
  return 'unknown';
};

const countryWorkProfile = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_COUNTRY_WORK_PROFILE_BEGIN:
      return {
        ...state,
        error: null,
        isFetching: true,
      };
    case FETCH_COUNTRY_WORK_PROFILE_SUCCESS:
      return {
        ...state,
        ...action.payload,
        error: null,
        isFetching: false,
      };
    case FETCH_COUNTRY_WORK_PROFILE_FAILURE:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };
    default:
      return state;
  }
};

export default countryWorkProfile;
